module.exports = __webpack_public_path__ + "static/img/icon_my_dashboard_ready.061037b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_my_dashboard_ready.svg
// module id = t7Km
// module chunks = 10